module.exports = __webpack_public_path__ + "fonts/FuturaStd-Book.0ab55089.woff2";